import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { PortalService, useToken } from './services';

import routes from '../../../constants/routes.json';

function WalletMenuItem() {
  const { getToken } = useToken();
  const [visible, setVisible] = useState(false);

  const handleBalance = useCallback(async () => {
    setVisible(false);

    try {
      const token = await getToken();
      const result = await PortalService.verifyBalance({ token });
      if (result.error) {
        throw new Error(result.msgError);
      }

      setVisible(true);
    } catch (err) {
      // err
    }
  }, []);

  useEffect(() => {
    handleBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) {
    return null;
  }
  
  return (
    <li className="nav-item">
        <Link className="nav-link" to={routes.CARTEIRA}>
            <i className="fas fa-solid fa-wallet text-danger mr-4" />
            <span>Carteira</span>
        </Link>
    </li>
  );
}

export default WalletMenuItem;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/WalletMenuItem.js